la-gutter-item {
  display: block;
}
